import {Component, Inject, OnInit, PLATFORM_ID} from '@angular/core';
import {isPlatformServer} from '@angular/common';
import {SeoService} from '../../core/services/seo.service';
import {TranslateService} from '@ngx-translate/core';
import {TokenDataProviderService} from '../../core/services/token-data-provider.service';

@Component({
  selector: 'app-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.scss']
})
export class SupportComponent implements OnInit {
  public readonly supportEmail = 'support@watchthisgarage.com';

  constructor(
    private readonly seo: SeoService,
    private readonly translate: TranslateService,
    private readonly tokenDataProvider: TokenDataProviderService,
    @Inject(PLATFORM_ID) private readonly platformId: object
  ) {}

  public get isAuthenticated(): boolean {
    return isPlatformServer(this.platformId)
      ? this.tokenDataProvider.isLoggedInSSR()
      : this.tokenDataProvider.isLoggedIn();
  }

  public ngOnInit(): void {
    const title = this.translate.instant('features.support.title');
    const description = this.translate.instant('features.support.meta_description');

    this.seo.setTitle(title);
    this.seo.setDescription(description);
    this.seo.setOpenGraph({title, description, url: this.seo.getAbsoluteUrl('/support'), type: 'website'});
    this.seo.setCanonical('/support');
    this.seo.setIndexable(true);
  }
}
